import getSafely from '@shared/utils/getSafely'
import { userStore } from '@/store/userStore'

// JSON.parse(decodeURIComponent(localStorage.getItem('userData')))
const { updateUser, resetUser } = userStore.getState()
const update = (_userData) => {
  let oldUserData = get()
  let userData = _userData
  if (oldUserData && oldUserData.userId && oldUserData.userId === userData.userId) {
    userData.enterprise.authModules = oldUserData.enterprise.authModules
  }
  const encodeData = getSafely(() => {
    return encodeURIComponent(JSON.stringify(userData))
  })
  if (encodeData) {
    // 更新到localStorage
    localStorage.setItem('userData', encodeData)
    // 更新到redux
    updateUser(userData)
  }
}

const stagingUserInfo = (userData) => { // 登录成功后，浏览器后退问题
  const encodeData = getSafely(() => {
    return encodeURIComponent(JSON.stringify(userData))
  })
  if (encodeData) {
    // 更新到localStorage
    localStorage.setItem('stagingUserInfo', encodeData)
  }
}

const getFromStorage = () => {
  return getSafely(() => {
    const userData = localStorage.getItem('userData')
    return JSON.parse(decodeURIComponent(userData))
  })
}

const getStagingUserInfo = () => {
  return getSafely(() => {
    const userData = localStorage.getItem('stagingUserInfo')
    return JSON.parse(decodeURIComponent(userData))
  })
}

const removeStagingUserInfo = () => {
  // 移除在localStorage的数据
  localStorage.removeItem('stagingUserInfo')
}

const get = getFromStorage

const remove = () => {
  // 移除在localStorage的数据
  localStorage.removeItem('userData')
  // 移除在redux的数据
  resetUser()
}

const isSuper = () => {
  // return true
  let userInfo = getFromStorage()
  let isSuper = false
  if (userInfo && userInfo.roles) {
    if (userInfo.roles.indexOf('SUPER_ADMIN') !== -1) { // 是否为超级管理员
      isSuper = true
    }
  }
  return isSuper
}

export default {
  update,
  stagingUserInfo,
  removeStagingUserInfo,
  getFromStorage,
  getStagingUserInfo,
  get,
  isSuper,
  remove
}
